module.exports = __webpack_public_path__ + "media/images/icons/analytics-c8acc95a7ff338522c8a508beca23225.svg";